import { Component } from '@angular/core';
import { AuthService } from '../security/auth.service';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    // styleUrls: ['./nav-menu.component.scss']
    styleUrls: ['../../styles.scss'],
    standalone: false
})
export class NavMenuComponent {
  isExpanded = true;
  showLive:boolean = true;
  showActive:boolean = true;
  showInventry:boolean = true;
  showContainerRegistry:boolean = true;
  showServiceFrequency:boolean = true;
  showDamageReport:boolean = true;
  showKpi:boolean = true;
  showVehicleUtilisation:boolean = false;
  showKpiReports:boolean = false;
  showTippingActivityReport:boolean = this.authService.userHasClaim("can_view_tipping_activity_report");
  
  // Constuctor
  constructor(private authService: AuthService) {
    authService.hasClaim("can_view_tipping_activity_report").subscribe(result => {
      if (result) {
        this.showLive = true;
        this.showActive = true;
        this.showInventry = true;
        this.showContainerRegistry = true;
        this.showServiceFrequency = false;
        this.showDamageReport = false;
        this.showKpi = false;
        this.showVehicleUtilisation = false;
        this.showKpiReports = false;
        this.showTippingActivityReport = true;
      } else {
        authService.hasClaim("is_yabby_only_user").subscribe(result => {
          if (result) {
            this.showLive = false;
            this.showActive = false;
            this.showInventry = true;
            this.showContainerRegistry = true;
            this.showServiceFrequency = true;
            this.showDamageReport = true;
            this.showKpi = false;
            this.showVehicleUtilisation = false;
            this.showKpiReports = false;
            this.showTippingActivityReport = false;
          }
          else {
            authService.hasClaim("is_container_only_user").subscribe(result => {
              if (result) {
                this.showLive = false;
                this.showActive = false;
                this.showInventry = false;
                this.showContainerRegistry = true;
                this.showServiceFrequency = false;
                this.showDamageReport = false;
                this.showKpi = false;
                this.showVehicleUtilisation = false;
                this.showKpiReports = false;
                this.showTippingActivityReport = false;
              }
            });
          }
        });
      }
    })
    
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
